import { LogoMark } from './LogoMark';

type LogoProps = {
  /** 'light' = for light backgrounds (dark wordmark), 'dark' = for dark backgrounds (white wordmark) — matches the Light/Dark lockups in Figma. */
  variant?: 'light' | 'dark';
  size?: number;
  className?: string;
};

export function Logo({ variant = 'dark', size = 22, className = '' }: LogoProps) {
  const textClass = variant === 'dark' ? 'text-text-inverse' : 'text-text-primary';

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <LogoMark size={size} />
      <span className={`font-semibold tracking-tight ${textClass}`} style={{ fontSize: Math.round(size * 0.64) }}>
        КСЕНУС ГИС
      </span>
    </span>
  );
}
